import { Box, IconButton, Modal, Typography } from '@mui/material'
import React from 'react'
import CouponConfigurableLabel from '../CouponConfigurableLabel';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { validationPopupTypes } from '../../types';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "55vw",
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display:'flex',
    flexDirection:'column',
    gap:'10px',
    borderRadius:'10px',
    minWidth:'600px'
  };


function ValidationPopUp(props:validationPopupTypes) {
    const {open , handleClose , content} = props;

  return (
    <Modal
        keepMounted={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <div className="validation-popup-header" style={{display:'flex',justifyContent:'center'}}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    <CouponConfigurableLabel text={"VALIDATION_POPUP_HEADER"} 
                      style={{
                        fontWeight:'600',
                        color:'black',
                        fontSize:'inherit',
                        textDecoration:'underline'
                      }}/>
                </Typography>
            </div>
            <div className="validation-popup-content" style={{maxHeight:'70vh',overflowY:'scroll'}}>
                {content}
            </div>

            <span style={{position:'absolute',top:'10px',right:'20px'}}>
              <IconButton onClick={handleClose}>
                <CloseOutlinedIcon/>
              </IconButton>
            </span>
        </Box>
      </Modal>
  )
}

export default ValidationPopUp